// gd-lib Auth.authenticatedUser() merges this cookie over localStorage.user,
// and the cookie wins. Keycloak must publish the same record gd-lib stores.
export const GROOVE_USER_COOKIE = 'db71ab6b0872a8afd28afe1adf7de4b5';
export const GROOVE_LOGOUT_SENTINEL = '4236a440a662cc8253d7536e5aa17942';

// js-cookie defaults: path "/", no Domain, no Expires (a session cookie).
// gd-lib adds SameSite=None and Secure and does not widen the domain.
export const GROOVE_USER_COOKIE_OPTIONS = { sameSite: 'None', secure: true };

export function readStoredUser(storage) {
  try {
    const parsed = JSON.parse(storage.getItem('user') || 'null');
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed;
  } catch (_) {
    return {};
  }
}

export function readSharedUserCookie(cookies) {
  try {
    const raw = cookies.get(GROOVE_USER_COOKIE);
    if (!raw || raw === GROOVE_LOGOUT_SENTINEL) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

export function applySharedUserToken(user, token) {
  return { ...(user && typeof user === 'object' ? user : {}), token, auth_keycloak: 1 };
}

// Field order matches gd-lib setUserCookie. Extra profile fields stay in
// localStorage and are not copied into the cookie.
export function sharedUserCookieRecord(user) {
  return {
    auth_keycloak: user.auth_keycloak,
    email: user.email,
    id: user.id,
    name: user.name,
    token: user.token,
    username: user.username
  };
}

export function publishedSharedUser(user) {
  const published = { ...(user && typeof user === 'object' ? user : {}) };
  delete published.refresh_token;
  delete published.refresh_expires_in;
  return published;
}

export function writeSharedUser(storage, cookies, user) {
  const published = publishedSharedUser(user);
  try {
    storage.setItem('user', JSON.stringify(published));
  } catch (_) { /* Storage may be blocked. The cookie still has to carry the token. */ }
  cookies.set(
    GROOVE_USER_COOKIE,
    JSON.stringify(sharedUserCookieRecord(published)),
    GROOVE_USER_COOKIE_OPTIONS
  );
  return published;
}

// gd-lib logout writes the sentinel instead of only deleting the cookie.
// authenticatedUser() treats that exact value as signed out.
export function clearSharedUser(storage, cookies) {
  try { if (storage) storage.removeItem('user'); } catch (_) { /* Storage may be blocked. */ }
  try {
    if (cookies) cookies.set(GROOVE_USER_COOKIE, GROOVE_LOGOUT_SENTINEL, GROOVE_USER_COOKIE_OPTIONS);
  } catch (_) { /* A restricted cookie jar must not prevent logout. */ }
}
